import { children, Component, ParentComponent, Show } from "solid-js";

type WidgetProps = {
  class?: string;
  onClick?: () => void;
  title: string;
  widgetIcon: Component;
};

export const DashboardWidget: ParentComponent<WidgetProps> = (props) => {
  const content = children(() => props.children);
  const className = () => {
    const allClassNames = ["Dashboard__Widget"];
    if (props.class) {
      allClassNames.push(props.class);
    }
    if (typeof props.onClick === "function") {
      allClassNames.push("Dashboard__Widget--clickable");
    }
    if (content()) {
      allClassNames.push("Dashboard__Widget--with-content");
    }
    if (props.class) {
      allClassNames.push(props.class);
    }
    return allClassNames.join(" ");
  };
  const onClick = () => props.onClick;
  const title = () => props.title;
  const widgetIcon = () => <props.widgetIcon />;

  return (
    <div class={className()} onClick={onClick()}>
      <header class="Dashboard__Widget__Header">
        <div class="Dashboard__Widget__Icon">{widgetIcon()}</div>
        <h2>{title()}</h2>
      </header>
      <main class="Dashboard__Widget__Content">
        <Show when={content()}>{content()}</Show>
      </main>
    </div>
  );
};
